import { motion } from "framer-motion";
import { Lock } from "lucide-react";

/** Livelli Creator = gemme. Diamante Nero e Red Diamond restano bloccati (in arrivo). */
export const LEVEL_STYLES = {
  1: { name: "Smeraldo", img: "/images/levels/smeraldo.png?v=3", ring: "#34d399",
       text: "text-emerald-200", chip: "from-emerald-500/25 to-teal-400/10 border-emerald-400/30" },
  2: { name: "Zaffiro", img: "/images/levels/zaffiro.png?v=3", ring: "#60a5fa",
       text: "text-sky-200", chip: "from-blue-600/25 to-cyan-400/10 border-blue-400/30" },
  3: { name: "Rubino", img: "/images/levels/rubino.png?v=3", ring: "#f43f5e",
       text: "text-rose-200", chip: "from-rose-600/25 to-red-400/10 border-rose-400/30" },
  4: { name: "Diamante", img: "/images/levels/diamante.png?v=3", ring: "#e5edf7",
       text: "text-slate-100", chip: "from-slate-200/25 to-white/10 border-white/35" },
  5: { name: "Diamante Nero", img: "/images/levels/diamante-nero.png?v=3", ring: "#a855f7",
       text: "text-violet-200", chip: "from-violet-700/30 to-indigo-500/10 border-violet-400/30", soon: true },
  6: { name: "Red Diamond", img: "/images/levels/red-diamond.png?v=3", ring: "#ff3b30",
       text: "text-red-200", chip: "from-red-700/30 to-orange-500/10 border-red-400/30", soon: true },
};

export const LevelGem = ({ level = 1, size = 22, locked = false, spin = false, className = "" }) => {
  const s = LEVEL_STYLES[level] || LEVEL_STYLES[1];
  return (
    <span className={`lv-gem ${className}`} style={{ width: size, height: size }}>
      <span className="lv-gem-glow" style={{ background: `radial-gradient(circle, ${s.ring}66, transparent 68%)` }} />
      <motion.img
        src={s.img} alt={s.name} draggable="false"
        animate={spin ? { y: [0, -5, 0], rotate: [0, 1.6, 0] } : undefined}
        transition={spin ? { duration: 4.2, repeat: Infinity, ease: "easeInOut" } : undefined}
        style={{
          filter: locked
            ? "grayscale(0.85) brightness(0.5) contrast(0.9)"
            : `drop-shadow(0 0 ${Math.round(size / 3)}px ${s.ring}aa)`,
        }}
      />
      {locked && <Lock className="lv-gem-lock" style={{ width: size * 0.34, height: size * 0.34 }} />}
    </span>
  );
};

export const CreatorLevelBadge = ({ level, size = "sm", locked = false, onClick }) => {
  if (!level || !level.level) return null;
  const s = LEVEL_STYLES[level.level] || LEVEL_STYLES[1];
  const compact = size === "sm";
  return (
    <button
      type="button"
      data-testid="creator-level-badge"
      onClick={onClick}
      className={`lv-badge ${onClick ? "lv-badge-tap" : ""} ${locked ? "lv-badge-locked" : ""}`}
      style={{
        "--lv-ring": s.ring,
        padding: compact ? "3px 9px 3px 4px" : "5px 13px 5px 6px",
      }}
    >
      <LevelGem level={level.level} size={compact ? 17 : 22} locked={locked} />
      <span className="lv-badge-name" style={{ fontSize: compact ? 9.5 : 11 }}>
        {level.name || s.name}
      </span>
    </button>
  );
};
